import React from 'react'
// libs
import styled from 'styled-components'
// components
import MaterialChip, { ChipProps } from '@mui/material/Chip'

const StyledMaterialChip = styled(({ color, margin, marginRight, ...rest }) => <MaterialChip {...rest} />)`
  && {
    ${({ color }) => color && `background-color: ${color}`};
    ${({ margin }) => margin && `margin: ${margin}`};
    ${({ marginRight }) => marginRight && `margin-right: ${marginRight}`};
  }
`

interface Props extends Omit<ChipProps, 'color'> {
  color?: string
  margin?: string
  marginRight?: string
}

const Chip: React.FC<Props> = (props) => <StyledMaterialChip {...(props as any)} />

export default Chip
